import MessageBarContent from './MessageBar.content.tsx';
import MessageBarProvider from './MessageBar.provider.tsx';
import './MessageBar.styles.scss';

export default function MessageBar() {
  return (
    <MessageBarProvider>
      <MessageBarContent />
    </MessageBarProvider>
  );
}
